import FeedbackStore from './feedback_store';
import FeedbackActions from './feedback_actions';

const fetchUnlessLoaded = (shop) => {
  const { feedbacks } = FeedbackStore.getState();

  if (feedbacks.length) {
    return;
  }

  // These actions are triggered before the shop 'loaded' action resolves, but after the store has
  // updated and passed new props to its children. These actions are deferred until the next
  // dispatch loop to avoid invariant violations in the Alt dispatcher.
  FeedbackActions.loadAllFeedback.defer(shop.slug);
  FeedbackActions.loadFeedbackSummary.defer(shop.id);
};

export default {
  fetchUnlessLoaded,
};
